// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/loginpage_right_image.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/login_bottom_image.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginPage {
    /* width: 100%; */
    height: 100%;
    background-color: rgba(0, 0, 0, 0.08) !important;
}

.login:focus {
    border-bottom: 1px solid #45852e !important;
}

.my-form {
    padding: 2em;
    color: #5b5b5b;
    max-width: 68vh;
    margin-inline: auto;
}

h1 {
    font-weight: bold;
    text-align: center;
    font-size: 2.5em;
}

.form-control.login {
    background-color: inherit;
    color: #5b5b5b;
    border: none;
    border-bottom: 1px solid rgba(51, 51, 51, 0.24);
    border-radius: 0;
    padding-left: 0;
}

.form-control:focus {
    border-color: #3a7425;
    box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.1);
}

.btn {
    border-radius: 0;
    width: 100%;
    font-weight: bold;
}

.my-form p {
    /* color: gray;
  text-align: center; */
}

.my-form p a {
    color: #45852e;
    text-decoration: none;
}

.my-form p a:hover {
    color: #000;
}

.outer_row {
    position: relative;
    /* inset:4.375rem 2rem; */
}

.outer_row .image-column {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 28.125rem;
    background-repeat: no-repeat;
    background-size: cover;
    height: 75vh;
}

.outer_row .image-column2 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 6.25rem;
    background-repeat: no-repeat;
    background-size: cover;
    height: 15vh;
}

.outer_row .bg-light-green {
    background-color: #b7cf53;
    height: 15vh;
}

.outer_row .bg-green {
    background-color: #45852e;
    height: 15vh;
}
.outer_row .bg-green_lighter {
    background-color: #80b036;
    height: 15vh;
}

.back_arrow::after {
    content: '';
    position: absolute;
    inset: 20px 20px;
    width: 15px;
    height: 15px;
    border-radius: 1.8px;
    border-top: 2.5px solid #211e1e;
    border-right: 2.5px solid #100f0f;
    border-bottom: 2px solid transparent;
    border-left: 2px solid transparent;
    transform: rotate(220deg);
}

/* Adjust radio button appearance */
input[type='radio'] {
    transform: scale(1.1);
    /* Adjust the scale to modify button size */
    margin-right: 5px;
    /* Adjust margin as needed */
    /* Change radio button color */
    appearance: none;
    width: 15px;
    /* Width of the radio button */
    height: 15px;
    /* Height of the radio button */
    border: 2px solid #333;
    /* Border color */
    background-color: #f5f5f6;
    border-radius: 50%;
    /* Makes the border round */
    outline: none;
    /* Remove default focus outline */
    transition: border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
    /* Smooth transition on hover */
    vertical-align: middle;
    /* Align radio button vertically */
}

/* Change radio button color on selection */
input[type='radio']:checked {
    border-color: #333;
    /* Change border color when selected */
    background-color: #80b036;
}

/* Set initial style for default checked button */
input[type='radio'][checked='checked'] {
    border-color: #333;
    /* Border color for default checked button */
    background-color: #80b036;
    /* Background color for default checked button */
}

/* Change style for unchecked button when the second one is checked */
input[type='radio'][value='enterprise']:checked ~ input[type='radio'][value='employee'] {
    border-color: #333;
    /* Border color for unchecked button */
    background-color: #f5f5f6;
    /* Background color for unchecked button */
}

/* Adjust space between radio button and label */
.custom-radio-label {
    margin-right: 10px;
    /* Adjust margin as needed */
    display: inline-block;
    /* Ensure consistent alignment */
    vertical-align: middle;
    /* Align label to middle */
}

.radio-group {
    display: flex;
    gap: 20px;
    /* Adjust space between buttons and labels */
    align-items: center;
    /* Align items vertically */
    margin-bottom: 10px;
    /* Adjust margin as needed */
}

.credentials-title {
    /*Adjust margin between title anf form*/
    margin-bottom: 15px;
    font-size: 24px;
}

.login-container .form-control {
    /*Adjust margin bottom between form controls*/
    margin-bottom: 10px;
}

.login:hover {
    /*Remove hover effect of by default bootstrap css*/
    background-color: transparent;
    color: #000;
}

.login:focus {
    border-bottom: 1px solid #45852e !important;
}

.login:focus {
    border-bottom: 1px solid #45852e !important;
    /* background-color: transparent !important; */
}

.login-container {
    height: 100vh;
    overflow-y: hidden;
    overflow-x: hidden;
}

.password-change-modal {
    margin: 0 auto;
    min-height: 100%;
}

.password-change-input {
    margin-top: 10px;
}

.password-input-group .password-change-input:focus {
    border-color: #45852e;
}

.reload-icon {
    font-size: 28px;
}

.captcha-container div {
    display: flex;
}

.password-input-group {
    position: relative;
}

.password-eye-btn {
    position: absolute;
    right: 10px;
    top: 35%;
}

.resend-otp {
    color: blue;
    text-align: end;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
}

.form-label {
    /* color: #000; */
    font-weight: 600;
    margin-bottom: 0;
    margin-top: 10px;
}

.loginPage .login-btn:hover {
    background-color: #80b036;
    color: #000;
    box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.3);
}

.login-btn:focus-visible {
    background-color: #45852e;
    color: #f5f5f6;
}
`, "",{"version":3,"sources":["webpack://./src/features/loginPage/LoginPage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,YAAY;IACZ,gDAAgD;AACpD;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,+CAA+C;IAC/C,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IAGrB,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI;uBACmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yDAAsE;IACtE,iBAAiB;IACjB,4BAA4B;IAC5B,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,yDAAmE;IACnE,eAAe;IACf,4BAA4B;IAC5B,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,+BAA+B;IAC/B,iCAAiC;IACjC,oCAAoC;IACpC,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA,mCAAmC;AACnC;IACI,qBAAqB;IACrB,2CAA2C;IAC3C,iBAAiB;IACjB,4BAA4B;IAC5B,8BAA8B;IAC9B,gBAAgB;IAChB,WAAW;IACX,8BAA8B;IAC9B,YAAY;IACZ,+BAA+B;IAC/B,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,2BAA2B;IAC3B,aAAa;IACb,iCAAiC;IACjC,4EAA4E;IAC5E,+BAA+B;IAC/B,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA,2CAA2C;AAC3C;IACI,kBAAkB;IAClB,sCAAsC;IACtC,yBAAyB;AAC7B;;AAEA,iDAAiD;AACjD;IACI,kBAAkB;IAClB,4CAA4C;IAC5C,yBAAyB;IACzB,gDAAgD;AACpD;;AAEA,qEAAqE;AACrE;IACI,kBAAkB;IAClB,sCAAsC;IACtC,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA,gDAAgD;AAChD;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,qBAAqB;IACrB,gCAAgC;IAChC,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,4CAA4C;IAC5C,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;IACvC,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,6CAA6C;IAC7C,mBAAmB;AACvB;;AAEA;IACI,kDAAkD;IAClD,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;IAC3C,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB","sourcesContent":[".loginPage {\n    /* width: 100%; */\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.08) !important;\n}\n\n.login:focus {\n    border-bottom: 1px solid #45852e !important;\n}\n\n.my-form {\n    padding: 2em;\n    color: #5b5b5b;\n    max-width: 68vh;\n    margin-inline: auto;\n}\n\nh1 {\n    font-weight: bold;\n    text-align: center;\n    font-size: 2.5em;\n}\n\n.form-control.login {\n    background-color: inherit;\n    color: #5b5b5b;\n    border: none;\n    border-bottom: 1px solid rgba(51, 51, 51, 0.24);\n    border-radius: 0;\n    padding-left: 0;\n}\n\n.form-control:focus {\n    border-color: #3a7425;\n    -webkit-box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.1);\n    -moz-box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.1);\n    box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.btn {\n    border-radius: 0;\n    width: 100%;\n    font-weight: bold;\n}\n\n.my-form p {\n    /* color: gray;\n  text-align: center; */\n}\n\n.my-form p a {\n    color: #45852e;\n    text-decoration: none;\n}\n\n.my-form p a:hover {\n    color: #000;\n}\n\n.outer_row {\n    position: relative;\n    /* inset:4.375rem 2rem; */\n}\n\n.outer_row .image-column {\n    background-image: url('../../assets/images/loginpage_right_image.png');\n    height: 28.125rem;\n    background-repeat: no-repeat;\n    background-size: cover;\n    height: 75vh;\n}\n\n.outer_row .image-column2 {\n    background-image: url('../../assets/images/login_bottom_image.png');\n    height: 6.25rem;\n    background-repeat: no-repeat;\n    background-size: cover;\n    height: 15vh;\n}\n\n.outer_row .bg-light-green {\n    background-color: #b7cf53;\n    height: 15vh;\n}\n\n.outer_row .bg-green {\n    background-color: #45852e;\n    height: 15vh;\n}\n.outer_row .bg-green_lighter {\n    background-color: #80b036;\n    height: 15vh;\n}\n\n.back_arrow::after {\n    content: '';\n    position: absolute;\n    inset: 20px 20px;\n    width: 15px;\n    height: 15px;\n    border-radius: 1.8px;\n    border-top: 2.5px solid #211e1e;\n    border-right: 2.5px solid #100f0f;\n    border-bottom: 2px solid transparent;\n    border-left: 2px solid transparent;\n    transform: rotate(220deg);\n}\n\n/* Adjust radio button appearance */\ninput[type='radio'] {\n    transform: scale(1.1);\n    /* Adjust the scale to modify button size */\n    margin-right: 5px;\n    /* Adjust margin as needed */\n    /* Change radio button color */\n    appearance: none;\n    width: 15px;\n    /* Width of the radio button */\n    height: 15px;\n    /* Height of the radio button */\n    border: 2px solid #333;\n    /* Border color */\n    background-color: #f5f5f6;\n    border-radius: 50%;\n    /* Makes the border round */\n    outline: none;\n    /* Remove default focus outline */\n    transition: border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n    /* Smooth transition on hover */\n    vertical-align: middle;\n    /* Align radio button vertically */\n}\n\n/* Change radio button color on selection */\ninput[type='radio']:checked {\n    border-color: #333;\n    /* Change border color when selected */\n    background-color: #80b036;\n}\n\n/* Set initial style for default checked button */\ninput[type='radio'][checked='checked'] {\n    border-color: #333;\n    /* Border color for default checked button */\n    background-color: #80b036;\n    /* Background color for default checked button */\n}\n\n/* Change style for unchecked button when the second one is checked */\ninput[type='radio'][value='enterprise']:checked ~ input[type='radio'][value='employee'] {\n    border-color: #333;\n    /* Border color for unchecked button */\n    background-color: #f5f5f6;\n    /* Background color for unchecked button */\n}\n\n/* Adjust space between radio button and label */\n.custom-radio-label {\n    margin-right: 10px;\n    /* Adjust margin as needed */\n    display: inline-block;\n    /* Ensure consistent alignment */\n    vertical-align: middle;\n    /* Align label to middle */\n}\n\n.radio-group {\n    display: flex;\n    gap: 20px;\n    /* Adjust space between buttons and labels */\n    align-items: center;\n    /* Align items vertically */\n    margin-bottom: 10px;\n    /* Adjust margin as needed */\n}\n\n.credentials-title {\n    /*Adjust margin between title anf form*/\n    margin-bottom: 15px;\n    font-size: 24px;\n}\n\n.login-container .form-control {\n    /*Adjust margin bottom between form controls*/\n    margin-bottom: 10px;\n}\n\n.login:hover {\n    /*Remove hover effect of by default bootstrap css*/\n    background-color: transparent;\n    color: #000;\n}\n\n.login:focus {\n    border-bottom: 1px solid #45852e !important;\n}\n\n.login:focus {\n    border-bottom: 1px solid #45852e !important;\n    /* background-color: transparent !important; */\n}\n\n.login-container {\n    height: 100vh;\n    overflow-y: hidden;\n    overflow-x: hidden;\n}\n\n.password-change-modal {\n    margin: 0 auto;\n    min-height: 100%;\n}\n\n.password-change-input {\n    margin-top: 10px;\n}\n\n.password-input-group .password-change-input:focus {\n    border-color: #45852e;\n}\n\n.reload-icon {\n    font-size: 28px;\n}\n\n.captcha-container div {\n    display: flex;\n}\n\n.password-input-group {\n    position: relative;\n}\n\n.password-eye-btn {\n    position: absolute;\n    right: 10px;\n    top: 35%;\n}\n\n.resend-otp {\n    color: blue;\n    text-align: end;\n    font-size: 12px;\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.form-label {\n    /* color: #000; */\n    font-weight: 600;\n    margin-bottom: 0;\n    margin-top: 10px;\n}\n\n.loginPage .login-btn:hover {\n    background-color: #80b036;\n    color: #000;\n    box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.3);\n}\n\n.login-btn:focus-visible {\n    background-color: #45852e;\n    color: #f5f5f6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
